<template>
    <div>
        <GmapMap
            class="w-full h-full !absolute left-0 top-0"
            :center="{ lat: this.mapInfo.lat, lng: this.mapInfo.lng }"
            :zoom="14"
            map-type-id="terrain"
        >

            <GmapMarker
                :position="{ lat: this.mapInfo.lat, lng: this.mapInfo.lng }"
            />
        </GmapMap>
    </div>
</template>

<script>
export default {
  name: "map-point",
    props: [ 'data' ],
    data() {
      return {
          mapInfo: JSON.parse(this.data),
      }
    }
    
}
</script>

<style lang="scss">
    .vue-map-container .vue-map {
        @apply w-full xl:-mr-[94px];
    }
    
    .gm-style {
        @apply filter grayscale;
    }
</style>